import { myAxios } from 'api/axios';

export const getInvestigatorsList = () => myAxios.get('/v1/investigator');

export const setDefaultMessageAddressee = (userId) =>
  myAxios.post(`/v1/investigator/setDefaultMessageAddressee?userId=${userId}`);
